import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { TimezoneModes, TimezoneService } from '../../services/timezone.service';
import { faCalendarAlt, faPortrait, faStreetView } from '@fortawesome/pro-light-svg-icons';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-timezone-selector',
  templateUrl: './timezone-selector.component.html',
  styleUrls: ['./timezone-selector.component.scss']
})
export class TimezoneSelectorComponent implements OnInit {

  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  public loading = true;
  public saving = false;
  public optionsTimezones: Array<any> = [];
  public procedureTimezoneName = '';
  public procedureTimezoneOffset = '';

  public form: UntypedFormGroup = this.fb.group({
    mode: new UntypedFormControl(null),
    timezone: new UntypedFormControl(null, [Validators.required])
  });

  public TimezoneModes = TimezoneModes;
  public faCalendarAlt = faCalendarAlt;
  public faPortrait = faPortrait;

  constructor(
    private api: ApiService,
    private data: DataService,
    private fb: UntypedFormBuilder,
    private timezone: TimezoneService
  ) { }

  ngOnInit(): void {
    this.loadTimezoneProcedure();
    this.data.timezones$.subscribe({
      next: (timezones: Array<any>) => {
        this.optionsTimezones = timezones;
        this.initForm();
        this.loading = false;
      }
    });
  }

  setMode(mode: string): void {
    this.form.get('mode').setValue(mode);
  }

  onSubmit(): void {
    const mode = this.form.get('mode').value;
    this.timezone.setTimezoneMode(mode);
    const timezone = (mode === TimezoneModes.Own) ? this.form.get('timezone').value?.zone_name : this.timezone.getTimezone('procedure').timezone;
    if (timezone && timezone !== this.timezone.getMyTimezone()) {
      this.saving = true;
      this.api.saveTimezone(timezone).subscribe({
        next: (result: any) => {
          this.timezone.setTimezone(result.data?.id, result.data?.timezone, result.data?.tz_offset);
          this.closeDialog();
        }
      }).add(() => {
        this.saving = false;
        this.closeDialog();
      });
    } else {
      this.closeDialog();
    }
  }

  onClose(): void {
    this.initForm();
    this.visibleChange.emit(this.visible);
  }

  private initForm(): void {
    this.form.patchValue({
      mode: this.timezone.getTimezoneMode(),
      timezone: this.optionsTimezones.find((timezone: any) => {
        return timezone.zone_name === this.timezone.getMyTimezone();
      })
    });
  }

  private loadTimezoneProcedure(): void {
    const timezone = this.timezone.getTimezone('procedure');
    if (timezone) {
      this.procedureTimezoneName = timezone.timezone;
      this.procedureTimezoneOffset = timezone.offset;
    }
  }

  private closeDialog(): void {
    this.visible = false;
    this.onClose();
  }

}
